import { useEffect, useRef, useState } from "react";
import { ChevronDown } from "lucide-react";
const Dropdown = ({ value, onChange, options, label, className = "" }) => {
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);
  useEffect(() => {
    const onClickOutside = (e) => {
      if (rootRef.current && !rootRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onClickOutside);
    return () => document.removeEventListener("mousedown", onClickOutside);
  }, []);
  const select = (opt) => {
    onChange({ target: { value: opt } });
    setOpen(false);
  };
  return (
    <div ref={rootRef} className={`relative ${className}`}>
      <button
        type="button"
        aria-label={label}
        aria-haspopup="listbox"
        aria-expanded={open}
        onClick={() => setOpen((o) => !o)}
        className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-medium
                   text-slate-600 dark:text-white/80 bg-transparent hover:bg-black/[0.05] dark:hover:bg-white/[0.06]
                   transition-colors duration-200 focus:outline-none focus-visible:ring-2
                   focus-visible:ring-violet-400/60"
      >
        <span className="truncate max-w-[110px]">{value || label}</span>
        <ChevronDown
          size={14}
          className={`shrink-0 text-slate-400 dark:text-white/50 transition-transform duration-200 ${open ? "rotate-180" : ""}`}
        />
      </button>

      <div
        role="listbox"
        className={`absolute right-0 z-30 mt-1.5 min-w-[140px] overflow-hidden rounded-xl
                    border border-black/10 dark:border-white/10 bg-white dark:bg-[#1B1D29]/95 backdrop-blur-xl
                    shadow-2xl shadow-black/10 dark:shadow-black/40
                    origin-top-right transition-all duration-150 ease-out
                    ${open ? "opacity-100 scale-100 translate-y-0" : "pointer-events-none opacity-0 scale-95 -translate-y-1"}`}
      >
        {options.map((opt) => (
          <button
            key={opt}
            role="option"
            aria-selected={opt === value}
            type="button"
            onClick={() => select(opt)}
            className={`w-full px-3.5 py-2 text-left text-xs transition-colors duration-150
              ${opt === value
                ? "bg-violet-500/10 text-violet-700 dark:bg-violet-500/15 dark:text-violet-200"
                : "text-slate-600 dark:text-white/70 hover:bg-black/[0.05] dark:hover:bg-white/[0.06] hover:text-slate-900 dark:hover:text-white"}`}
          >
            {opt}
          </button>
        ))}
      </div>
    </div>
  );
};
var Dropdown_default = Dropdown;
export { Dropdown_default as default };